const openNotification = (type, { title, message } = {}) => {
  const text = title || message || '';
  if (type === 'error') {
    console.error('[Notification]', text);
  } else {
    console.log('[Notification]', text);
  }
};

export default openNotification;
